import { joinPathsStringUtil } from 'packages/src'
import { REDUX_DOMAIN_LIST_KEY } from '../../constants/key'

export function getDataPathReduxUtil (path) {
  return joinPathsStringUtil(path, REDUX_DOMAIN_LIST_KEY.DATA)
}
